import './index.css'

import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import './i18n';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import Building from './app/building/Building.tsx';
import BuildingAdmin from './app/building-admin/BuildingAdmin.tsx';
import CompanyAdmin from './app/company-admin/CompanyAdmin.tsx';
import Unauthorized from './app/errors/unauthorized/Unauthorized.tsx';
import ExternalLogin from './app/external/External.tsx';
import Migration from './app/migration/Migration.tsx';
import RootLayout from './app/RootLayout.tsx';
import Login from './app/login/Login.tsx';
import MonthReportGroupedByWeek from "./app/month-report/MonthReportGroupedByWeek.tsx";
import Motd from './app/motd/Motd.tsx';
import Overview from './app/overview/Overview.tsx';
import Home from './app/Home.tsx';
import ParkingReport from './app/parking-report/ParkingReport.tsx';
import Parking from './app/parking/Parking.tsx';
import Preferences from './app/preferences/Preferences.tsx';
import Signup from './app/signup/Signup.tsx';
import Reservations from './app/reservations/Reservations.tsx';
import ReservationsList from './app/reservations/ReservationsList.tsx';
import {Theme} from './Theme.tsx';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <Theme>
            <BrowserRouter>
                <Routes>
                    <Route element={<RootLayout/>}>
                        <Route index element={<Home/>}/>
                        <Route path={"login"} element={<Login/>}/>
                        <Route path={"signup/:date?"} element={<Signup/>}/>
                        <Route path={"overview/:date?"} element={<Overview/>}/>
                        <Route path={"building"} element={<Building/>}/>
                        <Route path={"building-admin"} element={<BuildingAdmin/>}/>
                        <Route path={"company-admin"} element={<CompanyAdmin/>}/>
                        <Route path={"parking"} element={<Parking/>}/>
                        <Route path={"parking/illegal"} element={<ParkingReport/>}/>
                        <Route path={"preferences"} element={<Preferences/>}/>
                        <Route path={"motd"} element={<Motd/>}/>
                        <Route path={"monthly-report"} element={<MonthReportGroupedByWeek/>}/>
                        <Route path={"reservations"} element={<Reservations/>}/>
                        <Route path={"reservations-list"} element={<ReservationsList/>}/>

                        <Route path={"external-login"} element={<ExternalLogin/>}/>

                        <Route path={"migration"} element={<Migration/>}/>

                        <Route path={"errors/unauthorized"} element={<Unauthorized/>}/>
                    </Route>
                </Routes>
            </BrowserRouter>

        </Theme>
    </StrictMode>,
)